export { default as en } from './en.json.mjs';
"use strict";
const ENGLISH_LANGUAGES_SORTED = {
  ar: "Arabic",
  ca: "Catalan",
  zh: "Chinese",
  "zh-tw": "Chinese",
  cs: "Czech",
  da: "Danish",
  nl: "Dutch",
  en: "English",
  fr: "French",
  de: "German",
  el: "Greek",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  no: "Norwegian",
  pl: "Polish",
  pt: "Portuguese",
  // Temporary entry for store
  "pt-br": "Portuguese",
  "pt-pt": "Portuguese",
  ru: "Russian",
  es: "Spanish",
  // Temporary entry for store
  "es-es": "Spanish",
  "es-mx": "Spanish",
  sv: "Swedish",
  tr: "Turkish"
};
const TRANSLATION_LANGUAGES_LOCALIZED = {
  ar: "\u0639\u0631\u0628\u064A",
  ca: "Catal\xE0",
  zh: "\u4E2D\u6587",
  cs: "\u010Ce\u0161tina",
  da: "Dansk",
  nl: "Nederlands",
  en: "US",
  fr: "Fran\xE7ais",
  de: "Deutsch",
  el: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
  it: "Italiano",
  ja: "\u65E5\u672C\u8A9E",
  ko: "\uD55C\uAD6D\uC5B4",
  no: "Norsk",
  pl: "Polski",
  pt: "Portugu\xEAs",
  // Temporary entry for store
  "pt-br": "Brasil",
  "pt-pt": "Portugal",
  ru: "P\u0443\u0441\u0441\u043A\u0438\u0439",
  es: "Espa\xF1ol",
  // Temporary entry for store
  "es-es": "Espa\xF1a",
  "es-mx": "M\xE9xico",
  sv: "Svenska",
  "zh-tw": "\u6B63\u9AD4\u4E2D\u6587",
  tr: "T\xFCrk\xE7e"
};
export { ENGLISH_LANGUAGES_SORTED, TRANSLATION_LANGUAGES_LOCALIZED };
//# sourceMappingURL=index.mjs.map
